import React from 'react';
import Layout from '../../layout';






function Contactus() {
  return (
   <Layout>
      <section class="page-header padding">
           <div class="overlay"></div>
            <div class="container">
               <div class="section-heading mt-40 text-center">
                    <h4 class="sub-heading">Vision And Mission</h4>
                    <h2>High Quality Construction Solutions <br/>For Residentials &amp; Industries!</h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
            </div>
        </section>
         {/* <div class="map-wrapper bg-grey">
		    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8826.923787362664!2d-118.27754354757262!3d34.03471770929568!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c75ddc27da13%3A0xe22fdf6f254608f4!2sLos%20Angeles%2C%20California%2C%20Hoa%20K%E1%BB%B3!5e0!3m2!1svi!2s!4v1566525118697!5m2!1svi!2s" width="100%" height="400" frameborder="0" style={{border:0}} allowfullscreen=""></iframe>
		</div> */}

        <section class="contact-section padding bg-grey">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-lg-6 col-md-5">
                        <div class="contact-content">
                            <div class="section-heading mb-40">
                                <h2>Reach Out To Us In The <br/>Nearest <span>Office.</span></h2>
                            </div>
                            <ul class="contact-details">
                                <li><i class="fas fa-map-marker-alt"></i><span>Skycity Mall, 8th Floor, Plot 403/1-2 Block A.<br/> University Road, Mlalakuwa, P.O.Box 4756, Dar es Salaam, Tanzania.</span></li>
                                <li><i class="fas fa-envelope"></i><span>info@derm.co.tz</span></li>
                                <li><i class="fas fa-phone"></i><span>(+123) 456 789 101 <br/>+1-302-123-4567</span></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-7">
                        <div class="contact-form">
                            <form action="contact.php" method="post" id="ajax_contact" class="form-horizontal">
                                <div class="form-group colum-row row">
                                    <div class="col-sm-6 xs-padding">
                                        <input type="text" id="firstname" name="firstname" class="form-control" placeholder="First Name" required />
                                    </div>
                                    <div class="col-sm-6 xs-padding">
                                        <input type="text" id="lastname" name="lastname" class="form-control" placeholder="Last Name" required />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-6 xs-padding">
                                        <input type="email" id="email" name="email" class="form-control" placeholder="Email" required />
                                    </div>
                                    <div class="col-sm-6 xs-padding">
                                        <input type="text" id="phone" name="phone" class="form-control" placeholder="Phone Number" required />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-12 xs-padding">
                                        <textarea id="message" name="message" cols="30" rows="5" class="form-control message" placeholder="Message" required></textarea>
                                    </div>
                                </div>
                                <button id="submit" class="default-btn" type="submit">Send Message<span></span></button>
                                <div id="form-messages" class="alert" role="alert"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="sponsor-section">
            <div class="container">
                <div class="slider sponsor-carousel nav-style">
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-6.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-3.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                </div>
            </div>
        </div> 
   </Layout>
  );
}

export default Contactus;